import React, { Component } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

interface LoginModalProps {
  tool: string;
  show: boolean;
  error: string;
  message: string;
  handleClose: () => void;
  handleLogin: (email: string, password: string, clientId: string, clientSec: string) => void;
}

interface LoginModalState {
  clientId: string;
  clientSec: string;
  email: string;
  password: string;
}

export default class LoginModal extends Component<LoginModalProps, LoginModalState> {
  constructor(props: LoginModalProps) {
    super(props);
    this.state = this.getStateFromProps(props);
  }

  getStateFromProps(props: LoginModalProps) {
    const isLegacy = props.tool === 'MIGRATION_INFA_LEGACY_TO_IDMC';

    return {
      clientId: isLegacy ? "" : "rel_IaX2vIB",
      clientSec: isLegacy ? "" : "xm!xU~iL4UZ%~nO65soooiF46PFg2ryG",
      email: isLegacy ? "nandan.bhattacharya" : "TRAINEE_IaX2vIB",
      password: isLegacy ? "Times123$" : "Yvz00qSb0*",
    };
  }

  componentDidUpdate(prevProps: LoginModalProps) {
    if (prevProps.tool !== this.props.tool) {
      this.setState(this.getStateFromProps(this.props));
    }
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    this.setState({ [name]: value } as Pick<LoginModalState, keyof LoginModalState>);
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const { email, password, clientId, clientSec } = this.state;
    this.props.handleLogin(email, password, clientId, clientSec );
  };

  render() {
    const { show, handleClose } = this.props;
    const { email, password, clientId, clientSec } = this.state;

    return (
      <Modal show={show} onHide={handleClose}  backdrop="static"  centered scrollable>
        <Modal.Header closeButton>
          <Modal.Title>{this.props.tool==='MIGRATION_INFA_LEGACY_TO_IDMC'?'Login to IDMC':'Login to Reltio'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.handleSubmit}>
            {this.props.tool==='MIGRATION_INFA_LEGACY_TO_RELTIO' &&
              <>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Client Id</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Client Id"
                  name="clientId"
                  value={clientId}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formPassword">
                <Form.Label>Client Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Client Secret"
                  name="clientSec"
                  value={clientSec}
                  onChange={this.handleChange}
                  required
                />
              </Form.Group>
              </>
            }
            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>User Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Username"
                name="email"
                value={email}
                onChange={this.handleChange}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                name="password"
                value={password}
                onChange={this.handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100">
              Login
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }
}
